import he from 'he';

export const formatHTML = (message) => {
  // find and replace base64  [data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2w] by <img src="cid:image" />
  const imgRegex = /\[(data:image\/\w+;base64,[A-Za-z0-9+/]+={0,2})\]/g;
  const formattedMessage = message.replace(imgRegex, '<img src="$1" />');
  return he.decode(formattedMessage);
};
